import {inject, Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {ConfigurationService} from "../../../shared/services/configuration.service";
import {InactiveModeService} from "../../../shared/services/inactive-mode.service";
import {Observable} from "rxjs";
import {JsonataExpressionsService} from "./jsonata-expressions-service.model";

@Injectable({
    providedIn: 'root'
})
export class JsonataExpressionsDataService {
    private readonly http = inject(HttpClient);
    private readonly config = inject(ConfigurationService);
    private readonly inactiveMode = inject(InactiveModeService);

    private readonly api = this.config.configuration.api.backendUrl
    private readonly baseEndpoint = 'configuration/jsonata/settings'

    private get endpoint(): string {
        return this.inactiveMode.inactiveMode
            ? 'configuration/jsonata/all-settings'
            : 'configuration/jsonata/settings';
    }

    getJsonata(): Observable<JsonataExpressionsService[]> {
        return this.http.get<any>(`${this.api}/${this.endpoint}`);
    }

    getJsonataById(id: number): Observable<JsonataExpressionsService> {
        return this.http.get<JsonataExpressionsService>(`${this.api}/${this.endpoint}/${id}`);
    }

    postJsonata(body: JsonataExpressionsService): Observable<JsonataExpressionsService> {
        return this.http.post<JsonataExpressionsService>(`${this.api}/${this.baseEndpoint}`, body);
    }

    patchJsonata(body: JsonataExpressionsService, id: number): Observable<JsonataExpressionsService> {
        return this.http.patch<JsonataExpressionsService>(`${this.api}/${this.baseEndpoint}/${id}`, body);
    }
}
